





















































import { defineComponent, computed, PropType } from "@vue/composition-api";

export default defineComponent({
    name: "AppNotificationDialog",

    props: {
        value: { type: Boolean, default: false }, // v-model
        tone: { type: String as PropType<'warning' | 'alarm' | 'alert' | 'success'>, default: 'warning' },
        title: { type: String, default: "" },
        message: { type: String, default: "" },
        options: { type: Object as PropType<{ width?: number; zIndex?: number }>, default: null }
    },

    setup(props, ctx) {
        const model = computed({
            get: () => props.value,
            set: v => ctx.emit("input", v)
        });

        const option = computed(() => ({
            width: props.options?.width ?? 440,
            zIndex: props.options?.zIndex ?? 200
        }));

        // Tone-based icon + visual theme mapping
        const toneMeta = computed(() => {
            return {
                warning: {
                    icon: 'mdi-shield-alert-outline',
                    headerClass: 'header--warning',
                    titleClass: 'title--warning',
                    badgeClass: 'badge--warning',
                    iconClass: 'icon--warning',
                    defaultTitle: 'Warning'
                },
                alarm: {
                    icon: 'mdi-alarm-light-outline',
                    headerClass: 'header--alarm',
                    titleClass: 'title--alarm',
                    badgeClass: 'badge--alarm',
                    iconClass: 'icon--alarm',
                    defaultTitle: 'Alarm Triggered'
                },
                alert: {
                    icon: 'mdi-alert-outline',
                    headerClass: 'header--alert',
                    titleClass: 'title--alert',
                    badgeClass: 'badge--alert',
                    iconClass: 'icon--alert',
                    defaultTitle: 'Alert'
                },
                success: {
                    icon: 'mdi-check',
                    headerClass: 'header--success',
                    titleClass: 'title--success',
                    badgeClass: 'badge--success',
                    iconClass: 'icon--success',
                    defaultTitle: 'Success'
                }
            }[props.tone];
        });

        const resolvedTitle = computed(() => props.title || toneMeta.value.defaultTitle);

        // Emits OnOk and closes dialog
        const agree = () => {
            ctx.emit("input", false);
            ctx.emit("OnOk");
        };

        // Cancel event + close
        const cancel = () => {
            ctx.emit("input", false);
            ctx.emit("OnCancel");
        };

        return {
            model,
            option,
            toneMeta,
            resolvedTitle,
            agree,
            cancel
        };
    }
});
